import { useEffect, useState, useContext } from "react";
import styles from "./Control.module.css";
import { inventoryProducts } from "../Home/Home";
import { Button } from "@mui/material";
import { displayItem } from "../Home/Home";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";
import { useNavigate } from "react-router-dom";
import { moldingsiteName } from "../Search/Search";

export default function Control() {
  const [products, setProducts] = useState<inventoryProducts[]>([]);
  const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
  const [selectedManufacture, setSelectedManufacture] = useState<string>("");
  const [selectedMoldingSite, setSelectedMoldingSite] = useState<string>("");
  const [selectProduct, setSelectProduct] = useState<string[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string>("");
  const [selectedDisplay, setSelectedDisplay] = useState<string>("");
  const [selectDisplayItem, setSelectDisplayItem] = useState<boolean[]>([
    false,
    false,
    false,
  ]);
  const [reload, setReload] = useState<boolean>(false);
  const { auth, setAuth } = useContext(AuthContext) as AuthContextType;
  const [selectedOffice, setSelectedOffice] = useState<string>(
    auth.office ? auth.office : "函館店"
  );
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();

    const fetchSelectInit = async () => {
      const response = await fetch(`${baseUrl}/getmanufacture`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      const Manufactures = data.manufacture.map((item: Object) =>
        Object.values(item)
      );
      setSelectManufacture(Manufactures);
    };

    fetchSelectInit();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchProduct = async () => {
      const response = await fetch(`${baseUrl}/product`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          manufacture: selectedManufacture,
          moldingsite: selectedMoldingSite,
        }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setSelectProduct(data);
    };
    fetchProduct();
  }, [selectedManufacture, selectedMoldingSite]);

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await fetch(`${baseUrl}/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          office: selectedOffice,
          manufacture: selectedManufacture,
          moldingsite: selectedMoldingSite,
          productname: selectedProduct,
          display: selectedDisplay,
        }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        alert("セッションが切れました。再度ログインしてください");
        setAuth({
          username: null,
          isAuthenticated: false,
          office: undefined,
          authority: "user",
        });
        return navigate("/login");
      }
      setProducts(data);
    };

    fetchProducts();
  }, [
    selectedOffice,
    selectedManufacture,
    selectedMoldingSite,
    selectedProduct,
    selectedDisplay,
    reload,
    navigate,
    setAuth,
  ]);

  const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOffice(e.target.value);
  };

  const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedManufacture(e.target.value);
  };

  const handleMoldingSite = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMoldingSite(e.target.value);
    setSelectedProduct("");
  };

  const handleProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProduct(e.target.value);
  };

  const handleDisplay = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDisplay(e.target.value);
  };

  const handleDisplayItem = (index: number) => {
    let newDisplay = [...selectDisplayItem];
    newDisplay[index] = !newDisplay[index];
    setSelectDisplayItem(newDisplay);
  };

  const increment = async (index: number) => {
    const incrementItem = products[index];
    const response = await fetch(`${baseUrl}/increment`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(incrementItem),
    });
    const data = await response.json();
    if (data.isAuth === false) {
      alert("セッションが切れました。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    setReload(!reload);
  };

  const decrement = async (index: number) => {
    const decrementItem = products[index];
    const response = await fetch(`${baseUrl}/decrement`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(decrementItem),
    });
    const data = await response.json();
    if (data.isAuth === false) {
      alert("セッションが切れました。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    setReload(!reload);
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>在庫リスト</h2>
      <div className={styles.selectwrapper}>
        <p className={styles.p2}>絞り込み：</p>
        {auth.office ? (
          <p className={styles.p2}>{auth.office}</p>
        ) : (
          <label htmlFor="支店" className={styles.label}>
            支店
            <select
              value={selectedOffice}
              id="支店"
              onChange={handleOffice}
              className={styles.select}
            >
              <option value="函館店">函館店</option>
              <option value="札幌店">札幌店</option>
              <option value="釧路店">釧路店</option>
              <option value="室蘭店">室蘭店</option>
            </select>
          </label>
        )}
        <label htmlFor="メーカー" className={styles.label}>
          メーカー
          <select
            value={selectedManufacture}
            id="メーカー"
            onChange={handleManufacture}
            className={styles.select}
          >
            <option value="">未設定</option>
            {selectManufacture.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="装着部位" className={styles.label}>
          装着部位
          <select
            value={selectedMoldingSite}
            id="装着部位"
            onChange={handleMoldingSite}
            className={styles.select}
          >
            <option value="">未設定</option>
            {moldingsiteName.map((item) => (
              <option key={item.moldingsite} value={item.moldingsite + "%"}>
                {item.part}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="製品" className={styles.label}>
          製品
          <select
            value={selectedProduct}
            id="製品"
            onChange={handleProduct}
            className={styles.select}
          >
            <option value="">未設定</option>
            {selectProduct.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
        <label htmlFor="表示" className={styles.label}>
          表示
          <select
            value={selectedDisplay}
            id="表示"
            onChange={handleDisplay}
            className={styles.select}
          >
            <option value="">すべて</option>
            <option value="constant">定数在庫分</option>
            <option value="excess">超過分</option>
            <option value="temporarily">一時出庫分</option>
          </select>
        </label>
      </div>
      <div className={styles.checkwrapper}>
        <p className={styles.p2}>表示項目：</p>
        {displayItem.map((item, index) => (
          <label
            htmlFor={item.value}
            key={item.value}
            className={styles.checkArea}
          >
            {item.name}
            <input
              type="checkbox"
              id={item.value}
              onChange={() => handleDisplayItem(index)}
              className={styles.checkbox}
            />
          </label>
        ))}
      </div>
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th1}>メーカー</th>
              <th className={styles.th1}>製品名</th>
              <th className={styles.th2}>色</th>
              <th className={styles.th3}>左右</th>
              <th className={styles.th3}>サイズ</th>
              {selectDisplayItem[3] ? null : (
                <th className={styles.th3}>在庫数</th>
              )}
              {selectDisplayItem[0] ? (
                <th className={styles.th3}>定数</th>
              ) : null}
              {selectDisplayItem[1] ? (
                <th className={styles.th3}>超過分</th>
              ) : null}
              {selectDisplayItem[2] ? (
                <th className={styles.th3}>一時出庫</th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {products.map((item, index) => (
              <tr key={index} className={styles.tr}>
                <td className={styles.td}>{item.manufacture}</td>
                <td className={styles.td}>{item.productname}</td>
                <td className={styles.td}>{item.color}</td>
                <td className={styles.td}>{item.left_right}</td>
                <td className={styles.td}>{item.size}</td>
                {selectDisplayItem[3] ? null : (
                  <td className={styles.td}>{item.quantity}</td>
                )}
                {selectDisplayItem[0] ? (
                  <td className={styles.td2}>{item.constant}</td>
                ) : null}
                {selectDisplayItem[1] ? (
                  <td className={styles.td2}>
                    {item.quantity - item.constant > 0
                      ? item.quantity - item.constant
                      : null}
                  </td>
                ) : null}
                {selectDisplayItem[2] ? (
                  <td className={styles.td2}>
                    {item.temporarily_quantity
                      ? item.temporarily_quantity
                      : null}
                  </td>
                ) : null}
                <td className={styles.td2}>
                  <Button
                    variant="contained"
                    size="small"
                    key={index}
                    onClick={() => increment(index)}
                  >
                    入庫
                  </Button>
                </td>
                <td className={styles.td2}>
                  <Button
                    variant="contained"
                    size="small"
                    key={index}
                    onClick={() => decrement(index)}
                    disabled={item.quantity < 1}
                  >
                    出庫
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
